import classNames from 'classnames';
import { isArray } from 'lodash';
import { memo } from 'react';
import { LocalTournament, makeFloat } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { useLocalCurrency } from 'src/hooks/useLocalCurrency';

interface PrizePoolTournamentProps {
  tournament?: LocalTournament;
  className?: string;
  isTournamentNotification?: boolean;
}

const _PrizePoolTournament = ({
  tournament,
  className,
  isTournamentNotification
}: PrizePoolTournamentProps) => {
  const { t } = useTranslation();

  const { currencyIcon, currencyName } = useLocalCurrency();

  const hasPrizePool =
    tournament?.fullPrizePool?.amount &&
    !isArray(tournament.fullPrizePool?.amount) &&
    tournament.fullPrizePool?.amount[currencyName] !== 0;
  const hasFreespinPool = !!tournament?.freespinPool && tournament?.freespinPool !== 0;
  const hasPointsPool = !!tournament?.pointsPool && tournament?.pointsPool !== 0;

  const PRIZE_CLASSNAMES = isTournamentNotification
    ? 'truncate leading-[103%]'
    : 'whitespace-nowrap leading-[103%]';

  const prizePool = hasPrizePool && (
    <span className={PRIZE_CLASSNAMES}>
      {currencyIcon}
      {makeFloat(tournament.fullPrizePool.amount[currencyName])}
    </span>
  );
  const freeSpinPool = hasFreespinPool && (
    <span className={PRIZE_CLASSNAMES}>
      {hasPrizePool ? '\u00A0+ ' : ''}
      {tournament.freespinPool} {t('freeSpins.fs')}
    </span>
  );

  const pointsPool = hasPointsPool && (
    <span className={PRIZE_CLASSNAMES}>
      {hasPrizePool || hasFreespinPool ? '\u00A0+ ' : ''}
      {tournament.pointsPool} E.P.
    </span>
  );

  return (
    <p className={classNames(!isTournamentNotification && 'flex flex-row flex-wrap', className)}>
      {prizePool}
      {freeSpinPool}
      {pointsPool}
    </p>
  );
};

export const PrizePoolTournament = memo(_PrizePoolTournament);
